export default __webpack_public_path__ + "static/media/avatar-1.3921191a.jpg";